//@ts-ignore
import APIS from "../../constant/Endpoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import SwitchButton from "../Reusable/SwitchButton";
import { useQueryClient } from "@tanstack/react-query";


const FormsList = (props: any) => {
  const queryClient = useQueryClient();
  const { handleToggle } = props;
 
const onToggleAction = async (value: any, id: string, key: string) => {
  try {
    await handleToggle(value, id, key);
    if (key === "pin") {
      queryClient.invalidateQueries({ queryKey: ["forms"] });
      queryClient.invalidateQueries({ queryKey: ["pinned-forms"] });
      queryClient.invalidateQueries({ queryKey: ["form-builder"] });
      queryClient.invalidateQueries({ queryKey: ["form-table"] });
      
    }
  } catch (error) {
    console.error("Toggle failed:", error);
  }
};
  const defaultColumns: any = [
    {
      header: "Title",
      accessorKey: "title",
      cell: NACell,
    },
    {
      header: "Submission Limit",
      accessorKey: "submission_limit",
      cell: NACell,
    },
    {
      header: "Admin Notifications",
      accessorKey: "is_admin_notification",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value:any, id:string)=>handleToggle(value, id, "is_admin_notification")}
        />
      ),
    },
    {
      header: "Comment",
      accessorKey: "is_allow_comment",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value:any, id:string)=>handleToggle(value, id, "is_allow_comment")}
        />
      ),
    },
    {
      header: "SMS",
      accessorKey: "is_sms",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value:any, id:string)=>handleToggle(value, id, "is_sms")}
        />
      ),
    },
     {
      header: "Visible",
      accessorKey: "is_visible",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value:any, id:string)=>handleToggle(value, id, "is_visible")}
        />
      ),
    },
    {
      header: "Email",
      accessorKey: "is_email",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value:any, id:string)=>handleToggle(value, id, "is_email")}
        />
      ),
    },
    {
      header: "Reply",
      accessorKey: "is_reply",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value:any, id:string)=>handleToggle(value, id, "is_reply")}
        />
      ),
    },
    {
      header: "Pin",
      accessorKey: "pin",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value: any, id: string) => onToggleAction(value, id, "pin")}
        />
      ),
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={(value: any, id: string) => onToggleAction(value, id, "is_active")}
        />
      ),
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.FORM}
        queryKey={"forms"}
        params={{ form_type: "simple_form", limit: 10, offset: 0 }}
        columns={defaultColumns}
        tableName={"forms-list"}
        addNewPagePath={"create"}
      />
    </>
  );
};
export default FormsList;
